// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyB4ltVXY2YLbXmPBJb_XDXsIs06f_jZ3ow',
    authDomain: 'tugessi-services.firebaseapp.com',
    databaseURL: 'https://tugessi-services.firebaseio.com',
    projectId: 'tugessi-services',
    storageBucket: 'tugessi-services.appspot.com',
    messagingSenderId: '787596539998',
    appId: '1:787596539998:web:ebbed2f68fb57e0d105ccf',
    measurementId: 'G-WPK7YWNVND'
  },

  firebaseUrl: 'https://us-central1-tugessi-services.cloudfunctions.net/api/',

  // Epayco
  key: 'd6f49d0e425a53fb2eca115582464463',
  test: true,
  currencycode: 'cop',
  externalPasarela: 'false',
  urlconfirmation: 'https://us-central1-tugessi-services.cloudfunctions.net/api/epaycoAnswer',
  urlresponse: 'http://localhost:4200/epayco-response',
  testrequest: 'false'
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
}